import BsDropdownController from './dropdown_controller'

// usage:
//    btn {
//      data-controller="bs--dropdown-multilevel"
//      data-action="hide.bs.dropdown->bs--dropdown-multilevel#preventBsHide"
//    }
export default class extends BsDropdownController {
  // prevent hiding menu when clicking nested dropdown button
  // attach action "hide.bs.dropdown->dropdown#preventBsHide" to btn
  // use with default data-bs-autoclose="true" setting
  preventBsHide (e) {
    if (e.clickEvent) {
      const composedPath = e.clickEvent.composedPath()
      const isMenuTarget = composedPath.includes(this._bsComponent._menu)
      const isBtnTarget = composedPath.includes(
        e.clickEvent.target.closest("[data-controller*=dropdown]")
      )
      if (
        isMenuTarget &&
        isBtnTarget // nested btn dropdown
      ) {
        e.preventDefault();
      }
    }
  }
}
